import React from 'react'

import { Col, Grid } from '../../../../packages/kiti/components/structure/Grid'
import FormItem from '../../../../packages/kiti/components/form/form/FormItem'
import GroupSelect from '../../../../containers/groups/select/GroupSelect'
import PopoverEmojiPicker from '../../../../components/form/PopoverEmojiPicker'
import PopoverColorPicker from '../../../../components/form/PopoverColorPicker'
import { useIsOwner } from '@btime/react-session'
import { useTranslation } from 'react-i18next'

const GeneralSection = () => {
  const isOwner = useIsOwner()
  const { t } = useTranslation('processes')

  return (
    <Grid paddingGutter={0.5} wrap>
      <Col width="100%" wrapOn="sm">
        <FormItem label={`${t('processes.name')}*`} field="name" />
      </Col>
      <Col width="100%" wrapOn="sm">
        <FormItem label={t('processes.userGroups')} field={'userGroups'} Input={GroupSelect} multiple />
      </Col>
      <Col width="50%" wrapOn="sm">
        <FormItem
          label={`${t('processes.icon')}*`}
          field={'icon'}
          path={['data', 'configuration', 'icon']}
          Input={PopoverEmojiPicker}
        />
      </Col>
      <Col width="50%" wrapOn="sm">
        <FormItem
          label={`${t('processes.color')}*`}
          field={'color'}
          path={['data', 'configuration', 'color']}
          Input={PopoverColorPicker}
        />
      </Col>
      {isOwner && (
        <Col width="100%" wrapOn="sm">
          <FormItem
            label={t('processes.embedLink')}
            field={'embedLink'}
            path={['data', 'configuration', 'embedLink']}
          />
        </Col>
      )}
    </Grid>
  )
}

export default GeneralSection
